export const DepartAirlaneSVG = ({ fill }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.08333 15.8333H17.9167V17.5H2.08333V15.8333ZM18.3917 8.03333C18.2167 7.36667 17.525 6.96667 16.8583 7.15L12.4333 8.33333L6.66666 2.975L5.07499 3.4L8.52499 9.375L4.38332 10.4833L2.74166 9.2L1.53333 9.525L3.04999 12.1583L3.69166 13.2667L5.02499 12.9167L9.44999 11.725L13.075 10.7583L17.5 9.58333C18.175 9.38333 18.5667 8.7 18.3917 8.03333Z"
      fill={fill}
    />
  </svg>
)

export const ReturnAirlaneSVG = ({ fill }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.08333 15.8333H17.9167V17.5H2.08333V15.8333ZM8.06666 11.0583L11.6917 12.025L16.1167 13.2083C16.7833 13.3833 17.4667 12.9917 17.65 12.325C17.825 11.6667 17.4333 10.975 16.7667 10.7917L12.3417 9.60833L10.0417 2.08333L8.43333 1.66666V8.56666L4.29166 7.45833L3.51666 5.525L2.30833 5.2V9.50833L3.64166 9.86666L8.06666 11.0583Z"
      fill={fill}
    />
  </svg>
)

export const AddToTripIcon = ({ fill, iconSize }) => (
  <svg
    width={iconSize}
    height={iconSize}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.4458 4.37683C5.17229 4.41368 5.75 5.01435 5.75 5.75V12.9427C5.41493 12.9704 5.11133 13.1083 4.875 13.3199V5.75C4.875 5.47386 4.65114 5.25 4.375 5.25H2.625C2.34886 5.25 2.125 5.47386 2.125 5.75V14.625C2.125 14.9011 2.34886 15.125 2.625 15.125H3.875V16H2.625C1.86561 16 1.25 15.3844 1.25 14.625V5.75C1.25 5.01435 1.82771 4.41368 2.5542 4.37683L2.625 4.375H4.375L4.4458 4.37683Z"
      fill={fill}
    />
    <path
      d="M15.5542 4.37683C14.8277 4.41368 14.25 5.01435 14.25 5.75V12.9427C14.5851 12.9704 14.8887 13.1083 15.125 13.3199V5.75C15.125 5.47386 15.3489 5.25 15.625 5.25H17.375C17.6511 5.25 17.875 5.47386 17.875 5.75V14.625C17.875 14.9011 17.6511 15.125 17.375 15.125H16.125V16H17.375C18.1344 16 18.75 15.3844 18.75 14.625V5.75C18.75 5.01435 18.1723 4.41368 17.4458 4.37683L17.375 4.375H15.625L15.5542 4.37683Z"
      fill={fill}
    />
    <path
      d="M5.375 18H4.375L4.375 15H5.375L5.375 18ZM5.875 18.5L14.125 18.5C14.4011 18.5 14.625 18.2761 14.625 18V15C14.625 14.7239 14.4011 14.5 14.125 14.5L5.875 14.5C5.59886 14.5 5.375 14.7239 5.375 15H4.375C4.375 14.1845 5.02576 13.521 5.8363 13.5005L5.875 13.5L14.125 13.5C14.9534 13.5 15.625 14.1716 15.625 15V18C15.625 18.8284 14.9534 19.5 14.125 19.5H5.875C5.04657 19.5 4.375 18.8284 4.375 18H5.375C5.375 18.2761 5.59886 18.5 5.875 18.5Z"
      fill={fill}
    />
    <path
      d="M15.625 0.375C16.4534 0.375 17.125 1.04657 17.125 1.875V4.375H16.125V1.875C16.125 1.59886 15.9011 1.375 15.625 1.375H11.1338L10.0322 2.5L8.88379 1.375H4.375C4.09886 1.375 3.875 1.59886 3.875 1.875V4.375H2.875V1.875C2.875 1.05964 3.52557 0.396699 4.33594 0.375977L4.375 0.375H15.625Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1046 6.13106C12.167 6.09358 12.2414 6.08169 12.3123 6.09789C12.3832 6.11409 12.445 6.15713 12.4849 6.21797L12.7633 6.64266C12.7996 6.69814 12.8151 6.76466 12.8072 6.83047C12.7992 6.89629 12.7682 6.95717 12.7197 7.00238L12.7189 7.0035L12.7149 7.00716L12.6989 7.02206L12.6356 7.08253C12.2855 7.42219 11.946 7.77261 11.6175 8.13328C10.9996 8.81278 10.2658 9.7021 9.77195 10.565C9.63413 10.8057 9.29748 10.8575 9.09779 10.6496L7.27388 8.75457C7.24775 8.7274 7.22734 8.69525 7.21387 8.66004C7.2004 8.62483 7.19415 8.58726 7.19549 8.54959C7.19683 8.51191 7.20573 8.47489 7.22166 8.44072C7.23759 8.40655 7.26023 8.37594 7.28823 8.35069L7.83948 7.85344C7.88792 7.80976 7.95004 7.78428 8.0152 7.78136C8.08035 7.77844 8.1445 7.79825 8.19666 7.83741L9.12732 8.53519C10.5811 7.10166 11.4054 6.55153 12.1046 6.13106Z"
      fill={fill}
    />
  </svg>
)
